import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowImportIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 13C21.45 13 21 13.45 21 14V22H3V14C3 13.45 2.55 13 2 13C1.45 13 1 13.45 1 14V22C1 23.1 1.9 24 3 24H21C22.1 24 23 23.1 23 22V14C23 13.45 22.55 13 22 13Z"
        fill={color}
      />
      <path
        d="M11.29 18.71C11.68 19.1 12.31 19.1 12.7 18.71L18.7 12.71C19.09 12.32 19.09 11.69 18.7 11.3C18.31 10.91 17.68 10.91 17.29 11.3L13 15.59V1C13 0.45 12.55 0 12 0C11.45 0 11 0.45 11 1V15.59L6.71001 11.3C6.32001 10.91 5.69001 10.91 5.30001 11.3C4.91001 11.69 4.91001 12.32 5.30001 12.71L11.3 18.71H11.29Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowImportIcon.displayName = 'ArrowImportIcon';
